module.exports = __webpack_public_path__ + "img/open-x.6073d75a.png";